import React from 'react';

import { AdvertisingButton } from '@src/components/AdvertisingButton';
import { RedirectToMoreOffersButton } from '@src/components/RedirectToMoreOffersButton';
import { useCard, useCardAdvertising } from '@src/reducers/product';

export const ActionButton = () => {
  const card = useCard();
  const adv = useCardAdvertising();

  if (!card.advertising?.monetization) {
    return <RedirectToMoreOffersButton block>на Главную МФО</RedirectToMoreOffersButton>;
  }

  return <AdvertisingButton source="search_product" advSub={adv?.advSub} analytics={card} />;
};
